var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55556 5.55556H44.4444V44.4444H5.55556V5.55556ZM0 0H5.55556H44.4444H50V5.55556V44.4444V50H44.4444H5.55556H0V44.4444V5.55556V0ZM23.1648 31.7081L35.5097 19.3633L35.5097 19.3633L32.803 16.6566L32.803 16.6566L31.1789 15.0326L23.1648 23.0467L20.352 25.8596L16.5625 22.0701L16.5625 22.0702L14.9385 20.4461L10.6077 24.7769L20.3519 34.521L20.3521 34.5208L20.3521 34.5209L23.1648 31.7081ZM22.1827 22.0646L19.3754 19.2573L17.5446 21.088L20.352 23.8954L22.1827 22.0646ZM24.1476 32.691L24.7888 33.3322L24.789 33.332L24.789 33.332L39.9466 18.1745L35.6158 13.8437L33.7851 15.6745L37.4739 19.3633L24.1476 32.691Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.9bb8db74b35d310a1fc63145fd6e8826.svg";
export { ForwardRef as ReactComponent };